import React from "react";

const Family = (props) => {
  return (
    <svg
      viewBox="0 0 24 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9824 1.71683C16.2335 1.71708 19.8194 5.0449 20.4873 9.48929L20.5625 9.98929L21.0605 10.0752L21.3037 10.1299L21.3145 10.1328C21.7774 10.2585 22.0088 10.4066 22.125 10.5225C22.2262 10.6234 22.2769 10.7357 22.2939 10.9014C22.3133 11.0901 22.2868 11.3333 22.2158 11.6641C22.1811 11.8257 22.1391 11.9948 22.0928 12.1797C22.0474 12.3611 21.9979 12.5583 21.9531 12.7588L22.6357 12.9112L21.9521 12.7588V12.7608C21.8017 13.4458 21.6257 13.8705 21.4189 14.1045C21.2648 14.279 21.0534 14.398 20.5938 14.333L20.0576 14.2569L19.8496 14.7569C18.4981 18.0101 15.4694 20.2391 11.9824 20.2393C8.49962 20.2393 5.47011 18.0106 4.11426 14.7608L3.90918 14.2696L3.38086 14.336C2.92878 14.3926 2.72345 14.2733 2.57227 14.0987C2.39418 13.8928 2.24044 13.5435 2.10352 13.003L2.0459 12.7598C2.0016 12.5591 1.9524 12.3622 1.90723 12.1807C1.86115 11.9955 1.81878 11.8268 1.78418 11.6651C1.71335 11.3338 1.68672 11.0902 1.70605 10.9014C1.72306 10.7357 1.77371 10.6234 1.875 10.5225C1.99139 10.4066 2.22336 10.2586 2.6875 10.1328V10.1338L2.7002 10.1299C2.75959 10.1126 2.82105 10.1002 2.91992 10.0801L3.40039 9.98245L3.47266 9.4971C4.13669 5.04851 7.72292 1.71683 11.9824 1.71683Z"
        stroke={props.color}
        strokeWidth="1.4"
      />
      <path
        d="M9.31445 15.2883C9.31445 15.2883 10.0215 16.3952 12.1711 16.3952C14.3206 16.3952 15.0277 15.2883 15.0277 15.2883"
        stroke={props.color}
        strokeLinecap="round"
      />
      <path
        d="M20.971 8.34648C17.247 10.2797 14.0666 5.02915 15.918 1.96591C15.918 1.96591 18.0963 3.18213 19.0517 4.48911C20.368 6.29983 20.971 8.34648 20.971 8.34648Z"
        fill={props.color}
      />
      <path
        d="M16.2613 2.12913C13.9896 1.01728 11.4971 0.54532 8.99182 1.55732C6.48652 2.56933 5.30606 3.58133 3.49292 6.86239C6.9069 8.46439 13.7816 7.88802 16.2613 2.12913Z"
        fill={props.color}
      />
      <path
        d="M8.42843 12.0682C9.02006 12.0682 9.49968 11.5501 9.49968 10.911C9.49968 10.2719 9.02006 9.75378 8.42843 9.75378C7.83679 9.75378 7.35718 10.2719 7.35718 10.911C7.35718 11.5501 7.83679 12.0682 8.42843 12.0682Z"
        fill={props.color}
        stroke={props.color}
        strokeWidth="0.332073"
      />
      <path
        d="M15.5693 12.0682C16.1609 12.0682 16.6405 11.5501 16.6405 10.911C16.6405 10.2719 16.1609 9.75378 15.5693 9.75378C14.9777 9.75378 14.498 10.2719 14.498 10.911C14.498 11.5501 14.9777 12.0682 15.5693 12.0682Z"
        fill={props.color}
        stroke={props.color}
        strokeWidth="0.332073"
      />
    </svg>
  );
};

export default Family;
